import React from 'react';
import { useT } from '../i18n.jsx';

const modeKey = ownerId => `xapi.topup.crypto.${ownerId}`;
const readMode = ownerId => {
  try { return Boolean(ownerId) && sessionStorage.getItem(modeKey(ownerId)) === 'true'; }
  catch { return false; }
};

// Keep the manual-payment choice across Billing visits in this tab, per account.
export function useRechargeMode(ownerId) {
  const [selection, setSelection] = React.useState(() => ({ ownerId, crypto: readMode(ownerId) }));
  if (selection.ownerId !== ownerId) {
    setSelection({ ownerId, crypto: readMode(ownerId) });
  }
  const setCrypto = React.useCallback(crypto => {
    setSelection({ ownerId, crypto });
    try { if (ownerId) sessionStorage.setItem(modeKey(ownerId), String(crypto)); } catch {}
  }, [ownerId]);
  return [selection.ownerId === ownerId ? selection.crypto : readMode(ownerId), setCrypto];
}

export function RechargeModeSwitch({ checked, onChange, disabled = false }) {
  const { t } = useT();
  return <button type="button" role="switch" aria-checked={checked}
    aria-label={t('topup.useCrypto')} disabled={disabled}
    className="recharge-mode-switch" onClick={() => onChange(!checked)}>
    <span>{t('topup.useCrypto')}</span>
    <span className="recharge-mode-track" aria-hidden="true"><span /></span>
  </button>;
}
